<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'CRM.ASSOCIATION_PANEL.REPORTS.TITLE' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>

  <ng-container *ngIf="reportCardsReady$ | async; else loadingSpinner">
    <ng-container *ngIf="snapshot$ | async as snapshot; else createSnapshotButton">
      <ng-container *ngIf="(snapshotLoading$ | async) === false; else loadingSpinner">
        <mat-card class="association-card-contents-with-actions" appearance="outlined">
          <mat-card-title class="content-beside-actions">
            <a (click)="navToEditSnapshot()">{{ snapshotName$ | async }}</a>
            <mat-card-subtitle>
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.CREATED' | translate }}:
              {{ snapshot.created | date: 'mediumDate' }}
              <div class="status-badge">
                <ng-container *ngIf="snapshot.expired < this.now; else activeSnapshot">
                  <glxy-badge [color]="'grey'">
                    {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.STATUS.EXPIRED' | translate }}
                  </glxy-badge>
                </ng-container>
                <ng-template #activeSnapshot>
                  <glxy-badge [color]="'green'">
                    {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.STATUS.ACTIVE' | translate }}
                  </glxy-badge>
                </ng-template>
              </div>
            </mat-card-subtitle>
          </mat-card-title>
          <button mat-icon-button color="primary" [matMenuTriggerFor]="actions">
            <mat-icon class="gray-icon">more_vert</mat-icon>
          </button>
          <mat-menu #actions>
            <button mat-menu-item (click)="navToViewSnapshot()">
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.VIEW' | translate }}
            </button>
            <button mat-menu-item (click)="navToEditSnapshot()">
              {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.EDIT' | translate }}
            </button>
            <ng-container *ngIf="snapshot.expired < this.now">
              <button mat-menu-item (click)="refreshSnapshot()">
                {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.REFRESH' | translate }}
              </button>
            </ng-container>
          </mat-menu>
        </mat-card>
      </ng-container>
    </ng-container>
  </ng-container>
  @if (accountGroupId$ | async; as accountGroupId) {
    <mat-card class="association-card-contents-with-actions" appearance="outlined">
      <mat-card-title class="content-beside-actions">
        <a (click)="openExecReport(false)">{{ 'ADMINISTRATION.EXECUTIVE_REPORT.TITLE' | translate }}</a>
        <mat-card-subtitle>
          <a (click)="openExecReport(true)">{{ 'MANAGE_ACCOUNTS.ADMIN_VIEW' | translate }}</a>
        </mat-card-subtitle>
      </mat-card-title>
      <button mat-icon-button color="primary" [matMenuTriggerFor]="execActions">
        <mat-icon class="gray-icon">more_vert</mat-icon>
      </button>
      <mat-menu #execActions>
        <button mat-menu-item (click)="openExecReportSenderDialog()">
          {{ 'MANAGE_ACCOUNTS.RESEND_EXECUTIVE_REPORT' | translate }}
        </button>
      </mat-menu>
    </mat-card>
  } @else {
    @if (isAccountGroupLoading()) {
      <button mat-stroked-button color="primary" class="card-button" type="button" disabled>
        <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
      </button>
    } @else {
      <button mat-stroked-button color="primary" class="card-button" (click)="createAccount()">
        <mat-icon>add</mat-icon>
        {{ 'MANAGE_ACCOUNTS.CREATE_EXECUTIVE_REPORT' | translate }}
      </button>
    }
  }
</mat-expansion-panel>

<ng-template #createSnapshotButton>
  <ng-container [ngSwitch]="creatingSnapshot$ | async">
    <ng-container *ngSwitchCase="true" [ngTemplateOutlet]="createSnapshotDisabledButton"></ng-container>
    <ng-container *ngSwitchCase="false" [ngTemplateOutlet]="createSnapshotEnabledButton"></ng-container>
  </ng-container>
</ng-template>

<ng-template #createSnapshotEnabledButton>
  <ng-container *ngIf="snapshotName$ | async as snapshotName">
    <button mat-stroked-button color="primary" class="card-button" (click)="createSnapshot()">
      <mat-icon>note_add</mat-icon>
      <div>
        {{ 'CRM.ASSOCIATION_PANEL.REPORTS.SNAPSHOT_REPORT_CARD.ACTIONS.CREATE' | translate: { snapshotName } }}
      </div>
    </button>
  </ng-container>
</ng-template>

<ng-template #createSnapshotDisabledButton>
  <button mat-stroked-button color="primary" class="card-button" disabled>
    <glxy-loading-spinner size="small"></glxy-loading-spinner>
  </button>
</ng-template>

<ng-template #loadingSpinner>
  <glxy-loading-spinner id="spinner-container" [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
</ng-template>
